import React, { useState, useEffect } from 'react';
import { ClipboardList, CheckCircle, XCircle, Edit3, RefreshCw, Send } from 'lucide-react';
import api from '../../api';
import { format } from 'date-fns';

const actionConfig = {
    approved: { icon: <CheckCircle size={15} />, color: '#10b981', label: 'Approved' },
    rejected: { icon: <XCircle size={15} />, color: '#ef4444', label: 'Rejected' },
    needs_edits: { icon: <Edit3 size={15} />, color: '#f59e0b', label: 'Edits Requested' },
    submitted: { icon: <Send size={15} />, color: '#6366f1', label: 'Submitted' },
    resubmitted: { icon: <RefreshCw size={15} />, color: '#8b5cf6', label: 'Resubmitted' },
};

export default function AdminAuditLog() {
    const [log, setLog] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.getAuditLog()
            .then(data => setLog(data))
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    if (loading) return (
        <div className="admin-card-premium" style={{ padding: '48px', textAlign: 'center' }}>
            <p style={{ color: 'var(--admin-text-muted)' }}>Loading audit log...</p>
        </div>
    );

    return (
        <div>
            <div className="admin-page-header">
                <h1 className="admin-page-title">Audit Log</h1>
            </div>

            {log.length === 0 ? (
                <div className="admin-card-premium" style={{ padding: '64px', textAlign: 'center' }}>
                    <ClipboardList size={48} style={{ color: 'var(--admin-text-muted)', margin: '0 auto 16px', display: 'block', opacity: 0.4 }} />
                    <h3 style={{ color: 'var(--admin-text-main)', marginBottom: 8 }}>No Activity Yet</h3>
                    <p style={{ color: 'var(--admin-text-muted)' }}>Actions taken on events will be logged here.</p>
                </div>
            ) : (
                <div className="admin-table-container">
                    <table className="admin-table-premium">
                        <thead>
                            <tr>
                                <th>Action</th>
                                <th>Event</th>
                                <th>Actor</th>
                                <th>Note</th>
                                <th>Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {log.map((entry, i) => {
                                const cfg = actionConfig[entry.action] || { icon: null, color: '#6b7280', label: entry.action };
                                return (
                                    <tr key={i}>
                                        <td>
                                            <span style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 6,
                                                padding: '4px 12px',
                                                borderRadius: 20,
                                                fontSize: '0.82rem',
                                                fontWeight: 600,
                                                background: `${cfg.color}18`,
                                                color: cfg.color,
                                            }}>
                                                {cfg.icon}
                                                {cfg.label}
                                            </span>
                                        </td>
                                        <td style={{ fontWeight: 500 }}>
                                            {entry.eventTitle || `Event #${entry.eventId}`}
                                        </td>
                                        <td style={{ color: 'var(--admin-text-muted)', fontSize: '0.9rem' }}>
                                            {entry.actorEmail || '—'}
                                        </td>
                                        <td style={{ fontSize: '0.88rem', color: 'var(--admin-text-muted)', maxWidth: 260 }}>
                                            {entry.note || '—'}
                                        </td>
                                        <td style={{ fontSize: '0.85rem', color: 'var(--admin-text-muted)', whiteSpace: 'nowrap' }}>
                                            {entry.timestamp
                                                ? format(new Date(entry.timestamp), 'MMM d • h:mm a')
                                                : '—'}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
